module.exports = __webpack_public_path__ + "img/pigment_1.a9301d67.png";